import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DATE_FORMATS, MatDateFormats } from '@angular/material/core';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-flight-report',
  templateUrl: './flight-report.component.html',
  styleUrls: ['./flight-report.component.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class FlightReportComponent implements OnInit {

  reportCorporate: FormGroup;
  reportDetails = false
  listItem: any = [];
  range = new FormGroup ({
    reportFromDate: new FormControl (null, Validators.required ),
    reportToDate: new FormControl (null, Validators.required ),
  });
  columns = [
    { colKey: 'created_at', colName: 'Created', fullDate: true  },
    { colKey: 'travel_date', colName: 'Travel Date', fullDate: true },
    { colKey: 'air_cart_id', colName: 'Air Cart Id' },
    { colKey: 'booking_mode', colName: 'Booking Mode' },
    { colKey: 'pnr', colName: 'Pnr' },
    { colKey: 'booking_status', colName: 'Booking Status' },
    { colKey: 'passenger_name', colName: 'Passenger Name' },
    { colKey: 'ticket_number', colName: 'Ticket No.' },
    { colKey: 'air_class', colName: 'Air Class' },
    { colKey: 'airline_code', colName: 'Airline Code' },
    { colKey: 'airline_name', colName: 'Airline' },
    { colKey: 'sector', colName: 'Sector' },
    { colKey: 'basic_fare', colName: 'Basic Fare', amount: 'INR' },
    { colKey: 'tax_amount', colName: 'Tax Amount', amount: 'INR' },
    { colKey: 'other_tax', colName: 'Other Tax', amount: 'INR' },
    { colKey: 'gross_amount', colName: 'Gross Amount', amount: 'INR' },
    { colKey: 'commission_discount_gross', colName: 'Commission And Discount Gross', amount: 'INR' },
    { colKey: 'service_charges', colName: 'Service Charges', amount: 'INR' },
    { colKey: 'tds', colName: 'TDS', amount: 'INR' },
    { colKey: 'gst', colName: 'GST', amount: 'INR' },
    { colKey: 'net_ticket_amount', colName: 'Net Ticket Amount', amount: 'INR' }
  ]
  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.reportCorporate = this.fb.group({
      range: this.range
    });
  }

  get formattedRange() {
    const { reportFromDate, reportToDate } = this.range.value;
    return {
      reportFromDate: this.formatToYMD(reportFromDate),
      reportToDate: this.formatToYMD(reportToDate)
    };
  }

  formatToYMD(date: any): string {
    if (!date) return '';
    const d = date instanceof Date ? date : new Date(date);
    if (isNaN(d.getTime())) return ''; // Invalid date safe guard
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  submitReport() {
    if(this.range.valid) {
      console.log(this.formattedRange);
      this.reportDetails = true;
    } else {
      this.reportDetails = false; 
    }
  }

  resetReport() {
    this.reportDetails = false; 
    this.range.reset();
  }

  downloadReport() {}
}
